import type { PasswordStrength } from "./types";

export function evaluatePasswordStrength(password: string): PasswordStrength {
  const value = password ?? "";
  let score = 0;
  if (value.length >= 8) score += 1;
  if (value.length >= 12) score += 1;
  if (/[A-Z]/.test(value) && /[a-z]/.test(value)) score += 1;
  if (/\d/.test(value)) score += 1;
  if (/[^A-Za-z0-9]/.test(value)) score += 1;
  if (/[A-Z]/.test(value) && /[a-z]/.test(value) && /\d/.test(value) && value.length >= 14) score += 1;
  if (score <= 2) return "weak";
  if (score === 3) return "medium";
  if (score === 4 || score === 5) return "strong";
  return "very-strong";
}

export function passwordStrengthPercent(strength: PasswordStrength): number {
  switch (strength) {
    case "weak":
      return 25;
    case "medium":
      return 50;
    case "strong":
      return 75;
    case "very-strong":
      return 100;
  }
}

export function passwordStrengthColor(strength: PasswordStrength): string {
  switch (strength) {
    case "weak":
      return "var(--sc-identity-error)";
    case "medium":
      return "#d97706";
    case "strong":
      return "#0a7c33";
    case "very-strong":
      return "var(--sc-identity-success)";
  }
}
